import React from 'react';
import Button from 'react-bootstrap/Button';
import { FaFileExcel  } from "react-icons/fa";
import ReactExport from 'react-export-excel';
import { useI18n } from '../../../i18n';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const MonthlyReportXls = (props) => {
    const { t, tStatus, tCatalog } = useI18n();

    const chargeableLabel = (value) => {
        let key = 'Fixed';
        if (value === true || value === 'true' || value === 'Chargeable') key = 'Chargeable';
        else if (value === 'Quoted') key = 'Quoted';
        else if (value === false || value === 'false' || value === 'Fixed') key = 'Fixed';
        return tCatalog(key);
    };

    const formatElapsed = (from, to) => {
        if (!from || !to) return '';
        const diff = new Date(new Date(to) - new Date(from));
        const days = diff.getUTCDate() - 1;
        const time = ("0"+diff.getUTCHours()).slice(-2) +":"+ ("0"+diff.getUTCMinutes()).slice(-2);
        if (days > 0) {
            return t(days === 1 ? 'exportDoc.dayTime' : 'exportDoc.daysTime', { n: days, time });
        }
        return time;
    };

    const headerStyle = {border: {right: { style: "thick", color: {rgb: "558B2F"} }},};
    const headerStyle2 = {font: {bold: true, color: {rgb: "000000"}},fill: {patternType: "solid", fgColor: {rgb: "B0BEC5"}}, border: {right: { style: "thick", color: {rgb: "558B2F"}}, top: { style: "thin", color: {rgb: "000000"} }}};
    const headerStyle3 = {font: {color: {rgb: "000000"}},fill: {patternType: "solid", fgColor: {rgb: "9CCC65"}}, border: {bottom: { style: "thin", color: {rgb: "000000"} }}};
    const headerStyle4 = {font: {bold: true, color: {rgb: "000000"}},fill: {patternType: "solid", fgColor: {rgb: "B0BEC5"}}, border: {top: { style: "thin", color: {rgb: "000000"} }}};
    const headerStyle5 = {font: {color: {rgb: "000000"}},fill: {patternType: "solid", fgColor: {rgb: "9CCC65"}}, border: {right: { style: "thick", color: {rgb: "558B2F"}}, bottom: { style: "thin", color: {rgb: "000000"} }}};

    const topBorder = {top: {style: "medium", color: {rgb: "558B2F"}}};
    const mergeTopBorder = (existing) => {
        const base = existing ? {...existing} : {};
        base.border = {...(base.border || {}), ...topBorder};
        return base;
    };
    // react-export-excel has a bug: when a cell is passed as {value, style}, it never
    // assigns cell.t, so numeric values end up in the shared-strings table and crash
    // the writer ("s.t.match is not a function"). When we apply a style to a numeric
    // value we convert it to a string and right-align the cell so the result still
    // looks like a number.
    const buildCell = (value, baseStyle, isFirstRow, asNumber = false) => {
        const safeValue = value === undefined || value === null ? "" : value;
        const isNumberValue = typeof safeValue === 'number';
        const finalValue = isNumberValue ? safeValue.toString() : safeValue;
        const rightAlign = isNumberValue || asNumber;

        const applyStyle = (style) => {
            const finalStyle = style ? {...style} : {};
            if (rightAlign) {
                finalStyle.alignment = {...(finalStyle.alignment || {}), horizontal: "right"};
            }
            return finalStyle;
        };

        if (isFirstRow && baseStyle) {
            return {value: finalValue, style: mergeTopBorder(applyStyle(baseStyle))};
        }
        if (isFirstRow) {
            return {value: finalValue, style: mergeTopBorder(applyStyle(null))};
        }
        if (baseStyle) {
            return {value: finalValue, style: applyStyle(baseStyle)};
        }
        if (asNumber && finalValue !== "") {
            return {value: finalValue, style: applyStyle(null)};
        }
        return safeValue;
    };


        const dataRaw = props.dataSet;
        let data = [];
        for (let i = 0; i < dataRaw.length; i++) {
            if (dataRaw[i].date_completed){
                const d = new Date(dataRaw[i].date_completed);               
                dataRaw[i].date_completed_str = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear() + " "+ d.getHours() +":"+ ("0"+d.getMinutes()).slice(-2);
            }
            if (dataRaw[i].date_created){
                const d2 = new Date(dataRaw[i].date_created);               
                dataRaw[i].date_created_str = ("0"+d2.getDate()).slice(-2) + "-" + ("0"+(d2.getMonth()+1)).slice(-2) + "-" + d2.getFullYear()+ " "+ d2.getHours() +":"+ ("0"+d2.getMinutes()).slice(-2);
            }
            if (dataRaw[i].date_started){
                const d2 = new Date(dataRaw[i].date_started);               
                dataRaw[i].date_started_str = ("0"+d2.getDate()).slice(-2) + "-" + ("0"+(d2.getMonth()+1)).slice(-2) + "-" + d2.getFullYear()+ " "+ d2.getHours() +":"+ ("0"+d2.getMinutes()).slice(-2);
            }
            if (dataRaw[i].invoice_date){
                const d3 = new Date(dataRaw[i].invoice_date);
                dataRaw[i].invoice_date_str = ("0"+d3.getDate()).slice(-2) + "-" + ("0"+(d3.getMonth()+1)).slice(-2) + "-" + d3.getFullYear();
            } else {
                dataRaw[i].invoice_date_str = "";
            }

            const invNo = dataRaw[i].invoice_number;
            dataRaw[i].invoice_number_str = (invNo != null && invNo !== '') ? String(invNo).trim() : "";

            const materialLines = Array.isArray(dataRaw[i].materials_items) ? dataRaw[i].materials_items : [];
            if (dataRaw[i].callout_nr) dataRaw[i].callout_nr_str = parseFloat(dataRaw[i].callout_nr).toFixed(2); else dataRaw[i].callout_nr_str = "";
            if (dataRaw[i].callout_rate) dataRaw[i].callout_rate_str = parseFloat(dataRaw[i].callout_rate).toFixed(2); else dataRaw[i].callout_rate_str = "";
            if (dataRaw[i].callout_subtotal) dataRaw[i].callout_subtotal_str = parseFloat(dataRaw[i].callout_subtotal).toFixed(2); else dataRaw[i].callout_subtotal_str = "";
            if (dataRaw[i].onsite_nr) dataRaw[i].onsite_nr_str = parseFloat(dataRaw[i].onsite_nr).toFixed(2); else dataRaw[i].onsite_nr_str = "";
            if (dataRaw[i].onsite_rate) dataRaw[i].onsite_rate_str = parseFloat(dataRaw[i].onsite_rate).toFixed(2); else dataRaw[i].onsite_rate_str = "";
            if (dataRaw[i].onsite_subtotal) dataRaw[i].onsite_subtotal_str = parseFloat(dataRaw[i].onsite_subtotal).toFixed(2); else dataRaw[i].onsite_subtotal_str = "";
            if (dataRaw[i].total_cost) dataRaw[i].total_cost_str = parseFloat(dataRaw[i].total_cost).toFixed(2); else dataRaw[i].total_cost_str = "";


            const hpSiteLabel = dataRaw[i].hp_site ? t('users.yes') : t('users.no');
            const chargeableStr = chargeableLabel(dataRaw[i].chargeable);
            const slaAttendWork = formatElapsed(dataRaw[i].date_created, dataRaw[i].date_started);
            const slaRepairWork = formatElapsed(dataRaw[i].date_started, dataRaw[i].date_completed);

            const taskRows = Math.max(1, materialLines.length);
            for (let r = 0; r < taskRows; r++) {
                const isFirstRow = r === 0;
                const line = materialLines[r];
                const qty = line ? Number(line.quantity || 0) : '';
                const price = line ? Number(line.price || 0) : '';
                const lineTotal = line
                    ? (line.total !== undefined && line.total !== null
                        ? Number(line.total)
                        : +(parseFloat((Number(line.quantity || 0)) * (Number(line.price || 0)))).toFixed(2))
                    : '';

                data.push([
                    buildCell(isFirstRow ? dataRaw[i].task_ref : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].site_ref : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].district : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].charge_code : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].contractor_ref : "", null, isFirstRow),

                    buildCell(isFirstRow ? (dataRaw[i].site_address || "") : "", headerStyle, isFirstRow),

                    buildCell(isFirstRow ? dataRaw[i].fault_description : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].work_completed : "", null, isFirstRow),
                    buildCell(isFirstRow ? tCatalog(dataRaw[i].type_fault) : "", null, isFirstRow),

                    buildCell(isFirstRow ? tCatalog(dataRaw[i].category) : "", headerStyle, isFirstRow),

                    buildCell(line ? (line.itemId || "") : "", null, isFirstRow),
                    buildCell(line ? (line.description || "") : "", null, isFirstRow),
                    buildCell(line ? String(qty) : "", null, isFirstRow, true),
                    buildCell(line ? parseFloat(price).toFixed(2) : "", null, isFirstRow, true),
                    buildCell(line ? parseFloat(lineTotal).toFixed(2) : "", null, isFirstRow, true),
                    buildCell(isFirstRow ? dataRaw[i].callout_nr_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].callout_rate_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].callout_subtotal_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].onsite_nr_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].onsite_rate_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].onsite_subtotal_str : "", null, isFirstRow),

                    buildCell(isFirstRow ? (dataRaw[i].total_cost_str || "") : "", headerStyle, isFirstRow),

                    buildCell(isFirstRow ? dataRaw[i].date_created_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].contractor : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].user_completed_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].date_started_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].date_completed_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].invoice_date_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].invoice_number_str : "", null, isFirstRow),
                    buildCell(isFirstRow ? slaAttendWork : "", null, isFirstRow),
                    buildCell(isFirstRow ? slaRepairWork : "", null, isFirstRow),

                    buildCell(isFirstRow ? tStatus(dataRaw[i].task_status) : "", headerStyle, isFirstRow),

                    buildCell(isFirstRow ? hpSiteLabel : "", null, isFirstRow),
                    buildCell(isFirstRow ? tCatalog(dataRaw[i].urgent_fault) : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].sla_attend : "", null, isFirstRow),
                    buildCell(isFirstRow ? dataRaw[i].sla_repair : "", null, isFirstRow),
                    buildCell(isFirstRow ? chargeableStr : "", null, isFirstRow),
                ]);
            }

        }


        const dataHeader = [
        [   
            {value: t('fields.siteDetails') + " \n", style: headerStyle4},            
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle2},

            {value: t('exportDoc.detailsOfWorks') + " \n", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle2},

            {value: t('exportDoc.costs') + " \n", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle2},

            {value: t('exportDoc.progress') + " \n", style: headerStyle4},
            {value: "", style: headerStyle4},

            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle2},
            {value: "", style: headerStyle2},
            {value: "", style: headerStyle2},

            {value: t('exportDoc.contractRequirements') + " \n", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},
            {value: "", style: headerStyle4},

        ],
        [
            {value: t('exportDoc.taskRef'), style: headerStyle3},
            {value: t('fields.siteRef'), style: headerStyle3},
            {value: t('exportDoc.municipalDistrict'), style: headerStyle3},
            {value: t('exportDoc.costCode'), style: headerStyle3},
            {value: t('exportDoc.contractorJobRef'), style: headerStyle3},
            {value: t('fields.siteAddress'), style: headerStyle5},

            {value: t('exportDoc.descriptionOfFault'), style: headerStyle3},
            {value: t('exportDoc.descriptionOfWork'), style: headerStyle3},
            {value: t('exportDoc.typeOfFault'), style: headerStyle3},
            {value: t('common.category'), style: headerStyle5},

            {value: t('fields.itemId'), style: headerStyle3},
            {value: t('common.description'), style: headerStyle3},
            {value: t('fields.qty'), style: headerStyle3},
            {value: t('fields.rate'), style: headerStyle3},
            {value: t('common.total'), style: headerStyle3},
            {value: t('exportDoc.callOutNo'), style: headerStyle3},
            {value: t('exportDoc.callOutRate'), style: headerStyle3},
            {value: t('exportDoc.callOutSubtotal'), style: headerStyle3},
            {value: t('exportDoc.onsiteNo'), style: headerStyle3},
            {value: t('exportDoc.onSiteRate'), style: headerStyle3},
            {value: t('exportDoc.onSiteSubtotal'), style: headerStyle3},
            {value: t('fields.totalCost'), style: headerStyle5},

 
            {value: t('exportDoc.dateCreated'), style: headerStyle3},
            {value: t('common.contractor'), style: headerStyle3},
            {value: t('exportDoc.engineer'), style: headerStyle3},
            {value: t('exportDoc.dateContractorAttended'), style: headerStyle3},
            {value: t('exportDoc.dateCompleted'), style: headerStyle3},
            {value: t('fields.invoiceDate'), style: headerStyle3},
            {value: t('fields.invoiceNumber'), style: headerStyle3},
            {value: t('exportDoc.attendSite'), style: headerStyle3},
            {value: t('exportDoc.completeTask'), style: headerStyle3},
            {value: t('common.status'), style: headerStyle5},

            {value: t('exportDoc.hpSite'), style: headerStyle3},
            {value: t('exportDoc.urgent'), style: headerStyle3},
            {value: t('exportDoc.slaAttend'), style: headerStyle3},
            {value: t('exportDoc.slaCompleteTask'), style: headerStyle3},
            {value: t('fields.chargeable'), style: headerStyle3},
        ]    
    ];

        let dateFrom = ""
        if (props.dateFrom){
            const d = new Date(props.dateFrom);               
            dateFrom = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
        }
        let dateTo = ""
        if (props.dateTo){
            const d = new Date(props.dateTo);               
            dateTo = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
        }

        const reportName = props.name || t('exportDoc.monthlyReport');
        const dataSet = [
        {   columns: [reportName,"","", t('exportDoc.dateFrom') + ': ', dateFrom ,""," " + t('exportDoc.to') + ': ', dateTo],
            data: [...dataHeader,...data]
        },
        ]

        return (
            <div>
                <ExcelFile filename={reportName} element={<Button size="sm" variant="warning">{t('exportDoc.exportExcel')} &nbsp; 
					<FaFileExcel /></Button>}>
					<ExcelSheet dataSet={dataSet} name={reportName} />
				</ExcelFile> 
            </div>
        );
}

export default MonthlyReportXls;
